/* EnterView  */
const reveals = document.querySelectorAll('.reveal');
const revealUps = document.querySelectorAll('.reveal-up');

if (reveals.length > 0) {
  enterView({
    selector: '.reveal',
    enter: (el, i) => {
      el.classList.add('entered');
    },
    exit: el => {
      el.classList.remove('entered');
    },
    offset: 0.1
  });
}

if (revealUps.length > 0) {
  enterView({
    selector: '.reveal-up',
    enter: (el, i) => {
      el.classList.add('entered');
    },
    exit: el => {
      el.classList.remove('entered');
    },
    offset: 0.1
  });
}

/* Swiper Initialiser */
const fcDesktop = window.matchMedia('(min-width: 1024px)');

function initFeaturedCollectionSlider() {
  document.querySelectorAll('[data-featured-collection-slider]').forEach((el) => {
    if (el.swiper) el.swiper.destroy(true, true);

    const section = el.closest('.featured-collection');

    new Swiper(el, {
      direction: 'horizontal',
      slidesPerView: 1.2,
      spaceBetween: 20,
      loop: fcDesktop.matches,
      slidesOffsetBefore: fcDesktop.matches ? 0 : 20,
      slidesOffsetAfter: fcDesktop.matches ? 0 : 20,
      navigation: {
        nextEl: section.querySelector('.swiper-featured-collection-button-next'),
        prevEl: section.querySelector('.swiper-featured-collection-button-prev')
      },
      breakpoints: {
        768: {
          slidesPerView: 2.3,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 3.9,
          spaceBetween: 20
        }
      }
    });
  });
}

initFeaturedCollectionSlider();
fcDesktop.addEventListener('change', initFeaturedCollectionSlider);

new Swiper('.announcement-swiper', {
  loop: true,
  slidesPerView: 1,
  allowTouchMove: false,
  autoplay: {
    delay: 3500,
    disableOnInteraction: false
  },
  speed: 800
});

// MOBILE VIEWPORT HEIGHT FIX
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/* Toggle Class (Generic) */
function toggleClass(modalName, className = 'active') {
  var modalActive = document.querySelector(modalName);
  modalActive.classList.toggle(className);
}

function toggleMultipleClass(
  selector1,
  selector2,
  className = 'active'
) {
  const el1 = document.querySelector(selector1);
  const el2 = document.querySelector(selector2);

  if (el1) el1.classList.toggle(className);
  if (el2) el2.classList.toggle(className);
}

/* Toggle forgot password form */
const forgotPasswordButtons = document.querySelectorAll(
  '.login__forgot-password-button'
);

forgotPasswordButtons.forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    toggleClass('.login__form');
    toggleClass('.forgot-password-form');
  });
});

/* Open Cart */
function cartOpen() {
  document.querySelector('body').classList.add('js-my-cart-open');
}

/* FAQ Accordion */
document.querySelectorAll('[data-faq-item]').forEach(item => {
  const trigger = item.querySelector('[data-faq-trigger]');
  if (!trigger) return;
  trigger.addEventListener('click', () => {
    const isOpen = item.classList.contains('is-open');
    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });
});

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});

/* Liquid Ajax Cart */
liquidAjaxCart.subscribeToCartAjaxRequests(
  (state, subscribeToResult) => {
    if (state.requestType == 'add') {
      const form = state.info.initiator;
      let btnInner = '';

      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btnInner = btn.innerHTML;
        btn.innerHTML = 'Adding';
      }

      subscribeToResult(state => {
        const btn = form.querySelector('button[type="submit"]');
        if (state.responseData.ok) {
          cartOpen();
        }

        if (btn) {
          setTimeout(() => {
            btn.innerHTML = btnInner;
          }, 300);
        }
      });
    }
  }
);

/* Cart quantity plus/minus — delegated because the cart re-renders on every update */
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-cart-qty-action]');
  if (!btn) return;

  const input = btn.closest('[data-cart-qty]')?.querySelector('input[data-ajax-cart-quantity-input]');
  if (!input) return;

  const current = parseInt(input.value, 10) || 0;
  const next = btn.dataset.cartQtyAction === 'increase' ? current + 1 : Math.max(0, current - 1);
  if (next === current) return;

  input.value = next;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* Hero Slider */
function initHeroSlider(context = document) {
  const sliders = context.querySelectorAll('.hero-slider .swiper');
  if (!sliders.length) return;

  sliders.forEach(sliderEl => {
    if (sliderEl.classList.contains('swiper-initialized')) return;

    const wrapper = sliderEl.closest('.hero-slider');
    const progressBars = wrapper.querySelectorAll(
      '.progress-bar__fill'
    );
    const navButtons = wrapper.querySelectorAll('.hero-slider__btn');

    let hasTriggered = false;

    const swiper = new Swiper(sliderEl, {
      loop: true,
      speed: 600,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },

      on: {
        init() {
          setActiveNav(this.realIndex);
        },

        slideChange(swiper) {
          setActiveNav(swiper.realIndex);

          hasTriggered = false;
        },

        autoplayTimeLeft(swiper, time, progress) {
          const activeIndex = swiper.realIndex;
          const percentage = (1 - progress) * 100;

          progressBars.forEach((bar, i) => {
            if (i < activeIndex) {
              bar.style.width = '100%';
            } else if (i === activeIndex) {
              bar.style.width = `${percentage}%`;
            } else {
              bar.style.width = '0%';
            }
          });

          if (percentage > 92 && !hasTriggered) {
            hasTriggered = true;
            swiper.slideNext();
          }
        }
      }
    });

    function setActiveNav(index) {
      navButtons.forEach(btn => btn.classList.remove('is-active'));
      if (navButtons[index]) {
        navButtons[index].classList.add('is-active');
      }
    }

    navButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const index = parseInt(btn.dataset.slide);
        swiper.slideToLoop(index);

        hasTriggered = false;
      });
    });
  });
}

// Load more button function (collections, search)
function initLoadMore() {
  const buttons = document.querySelectorAll('.js-load-more');
  if (!buttons.length) return;

  buttons.forEach(button => {
    if (button.dataset.initialized) return;
    button.dataset.initialized = true;

    button.addEventListener('click', function () {
      const nextUrl = button.dataset.nextUrl;
      const containerSelector = button.dataset.container;

      if (!nextUrl || !containerSelector) return;

      const container = document.querySelector(containerSelector);
      if (!container) return;

      button.classList.add('is-loading');

      fetch(nextUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newContainer = doc.querySelector(containerSelector);
          const newButton = doc.querySelector('.js-load-more');

          if (newContainer) {
            const temp = document.createElement('div');
            temp.innerHTML = newContainer.innerHTML;

            const newItems = temp.querySelectorAll('.reveal-up');

            newItems.forEach(el => {
              el.classList.remove('entered');
            });

            while (temp.firstChild) {
              container.appendChild(temp.firstChild);
            }

            requestAnimationFrame(() => {
              newItems.forEach((el, i) => {
                el.classList.add('entered');
              });
            });

            if (typeof lazyLoadInstance !== 'undefined') {
              lazyLoadInstance.update();
            }
          }
          if (newButton) {
            button.dataset.nextUrl = newButton.dataset.nextUrl;
          } else {
            button.remove();
          }
        })
        .finally(() => {
          button.classList.remove('is-loading');
        });
    });
  });
}

// END OF LOAD MORE BUTTON

// Account nav
function handleAccountPageNav() {
  const pathname = window.location.pathname;
  const hash = window.location.hash;
  const links = document.querySelectorAll('.account-nav-link');

  if (!links.length) return;

  links.forEach(link => link.classList.remove('active'));

  if (pathname === '/account') {
    const sections = document.querySelectorAll('.account-section');

    sections.forEach(section => section.classList.add('hidden'));

    const currentHash = hash || '#dashboard';
    const sectionId = currentHash.replace('#', 'account-');
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.remove('hidden');
    }

    links.forEach(link => {
      const hrefHash = link.getAttribute('href').split('#')[1];
      if (`#${hrefHash}` === currentHash) {
        link.classList.add('active');
      }
    });

    if (!hash) {
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}#dashboard`
      );
    }
  }

  if (pathname.includes('/account/addresses')) {
    const addressLink = document.getElementById('addresses-link');
    addressLink?.classList.add('active');
  }
}

// Product Recommendations (PDP)
function initProductRecommendations(context = document) {
  const sections = context.querySelectorAll(
    '[data-product-recommendations]'
  );
  if (!sections.length) return;

  sections.forEach(section => {
    if (section.dataset.loaded === 'true') return;

    const url = section.dataset.url;

    // Manual/metafield mode — products are already in the DOM, just init the swiper
    if (!url) {
      const wrapper = section.querySelector('.swiper-wrapper');
      if (wrapper && wrapper.children.length > 0) {
        initRecommendationSwiper(section);
        section.dataset.loaded = 'true';
      }
      return;
    }

    const wrapper = section.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const temp = document.createElement('div');
        temp.innerHTML = html;

        const newSlides = temp.querySelectorAll(
          '.product-recommendations__card'
        );
        if (!newSlides.length) return;

        wrapper.innerHTML = '';

        newSlides.forEach(slide => {
          wrapper.appendChild(slide);
        });

        if (typeof lazyLoadInstance !== 'undefined') {
          lazyLoadInstance.update();
        }

        initRecommendationSwiper(section);

        section.dataset.loaded = 'true';
      })
      .catch(err => {
        console.error('Recommendation fetch failed:', err);
      });
  });
}

// Product recommendations swiper
function initRecommendationSwiper(section) {
  const swiperEl = section.querySelector(
    '[data-recommendation-swiper]'
  );
  if (!swiperEl) return;

  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  new Swiper(swiperEl, {
    direction: 'horizontal',
    slidesPerView: 1.2,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: section.querySelector(
        '.swiper-recommendations-button-next'
      ),
      prevEl: section.querySelector(
        '.swiper-recommendations-button-prev'
      )
    },
    breakpoints: {
      768: {
        slidesPerView: 2.3,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 3.9,
        spaceBetween: 20
      }
    }
  });

  // Bind "View options" quick-add on the (async-loaded) cards and on
  // Swiper's loop clones, which exist only after Swiper initialises.
  if (window.ProductCardQuickAdd) {
    window.ProductCardQuickAdd.initWithin(section);
  }
}

// Collection Filtering //
function initCollectionFacets() {
  const root = document.querySelector('.js-collection-page');
  if (!root) return;

  const form = root.querySelector('#FiltersForm');
  if (!form) return;

  const dropdowns = root.querySelectorAll('[data-filter-dropdown]');

  const closeAll = () => {
    dropdowns.forEach(d => {
      d.classList.remove('is-open');
      d.querySelector('[data-filter-trigger]')?.setAttribute('aria-expanded', 'false');
    });
  };

  dropdowns.forEach(dropdown => {
    const trigger = dropdown.querySelector('[data-filter-trigger]');

    trigger.addEventListener('click', () => {
      const isOpen = dropdown.classList.contains('is-open');
      closeAll();
      if (!isOpen) {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', e => {
    if (e.target.closest('[data-filter-dropdown]')) return;
    closeAll();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeAll();
  });

  // Apply on submit: rebuild the URL from every checked filter
  form.addEventListener('submit', e => {
    e.preventDefault();

    const params = new URLSearchParams();

    form.querySelectorAll('input:checked').forEach(input => {
      params.append(input.name, input.value);
    });

    const current = new URLSearchParams(window.location.search);
    if (current.get('sort_by')) params.set('sort_by', current.get('sort_by'));

    const query = params.toString();
    window.location.href = query
      ? `${form.action.split('?')[0]}?${query}`
      : form.action.split('?')[0];
  });
}

// Announcement bar
function initAnnouncementBar() {
  const body = document.body;
  const bar = document.getElementById('announcement-bar');

  if (!bar) return;

  bar.classList.remove('hidden-by-default');
  body.classList.add('announcement-bar-visible');
}

function initGeoModal() {
  const modal = document.getElementById('geo-modal');
  if (!modal) return;

  if (localStorage.getItem('geoModalSeen')) return;

  const shopBtn = modal.querySelector('#geo-modal-shop');

  setTimeout(() => {
    modal.classList.add('active');
  }, 1200);

  function closeModal() {
    modal.classList.remove('active');
    localStorage.setItem('geoModalSeen', 'true');
  }

  shopBtn?.addEventListener('click', () => {
    const form = modal.querySelector('form');

    localStorage.setItem('geoModalSeen', 'true');

    if (form && form.dataset.currencyChanged === 'true') {
      form.submit();
    } else {
      closeModal();
    }
  });
}

function initCurrencySelectors() {
  const selectors = document.querySelectorAll('.currency-selector');
  if (!selectors.length) return;

  selectors.forEach(selector => {
    const form = selector.closest('form');
    const insideModal = selector.closest('#geo-modal');

    resizeCurrencySelector(selector);

    selector.addEventListener('change', () => {
      resizeCurrencySelector(selector);

      if (insideModal) {
        form.dataset.currencyChanged = 'true';
        return;
      }

      form.submit();
    });
  });
}

function resizeCurrencySelector(selector) {
  let temp = selector._tempMeasure;

  if (!temp) {
    temp = document.createElement('span');
    temp.style.visibility = 'hidden';
    temp.style.position = 'absolute';
    temp.style.whiteSpace = 'nowrap';
    temp.style.font = window.getComputedStyle(selector).font;

    document.body.appendChild(temp);
    selector._tempMeasure = temp;
  }

  const text = selector.options[selector.selectedIndex].text;
  temp.textContent = text;

  const textWidth = temp.offsetWidth;

  const style = window.getComputedStyle(selector);
  const padding =
    parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);

  selector.style.width = textWidth + padding + 'px';
}

// Before & After Slider — before/after comparison slider
function initBeforeAfterSlider(context = document) {
  const sliders = context.querySelectorAll('[data-before-after]');

  sliders.forEach(slider => {
    if (slider.dataset.baReady === 'true') return;
    slider.dataset.baReady = 'true';

    const handle = slider.querySelector('[data-before-after-handle]');
    let dragging = false;

    const setPos = pct => {
      const clamped = Math.max(0, Math.min(100, pct));
      slider.style.setProperty('--pos', clamped + '%');
      if (handle) {
        handle.setAttribute('aria-valuenow', Math.round(clamped));
      }
    };

    const posFromEvent = clientX => {
      const rect = slider.getBoundingClientRect();
      setPos(((clientX - rect.left) / rect.width) * 100);
    };

    const onMove = e => {
      if (!dragging) return;
      posFromEvent(e.clientX);
    };

    const stop = () => {
      dragging = false;
    };

    // Start dragging from anywhere on the slider for a generous hit area
    slider.addEventListener('pointerdown', e => {
      dragging = true;
      posFromEvent(e.clientX);
    });
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', stop);
    window.addEventListener('pointercancel', stop);

    // Keyboard control
    if (handle) {
      handle.addEventListener('keydown', e => {
        const current = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          setPos(current - 2);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          setPos(current + 2);
        } else if (e.key === 'Home') {
          e.preventDefault();
          setPos(0);
        } else if (e.key === 'End') {
          e.preventDefault();
          setPos(100);
        }
      });
    }
  });
}

// Accordion & Statement — one item open at a time
function initStatementAccordion(context = document) {
  context.querySelectorAll('[data-statement-accordion]').forEach(group => {
    if (group.__statementBound) return;
    group.__statementBound = true;

    const items = group.querySelectorAll('[data-statement-item]');
    items.forEach(item => {
      const trigger = item.querySelector('[data-statement-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        const willOpen = !item.classList.contains('is-open');

        items.forEach(other => {
          other.classList.remove('is-open');
          const t = other.querySelector('[data-statement-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        if (willOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
}

// Init functions
window.addEventListener('hashchange', handleAccountPageNav);

document.addEventListener('DOMContentLoaded', function () {
  initLoadMore();
  handleAccountPageNav();
  initProductRecommendations();
  initCollectionFacets();
  initAnnouncementBar();
  initGeoModal();
  initCurrencySelectors();
  initHeroSlider();
  initBeforeAfterSlider();
  initStatementAccordion();
});

document.addEventListener('shopify:section:load', event => {
  initFeaturedCollectionSlider();
  initProductRecommendations(event.target);
  initHeroSlider(event.target);
  initBeforeAfterSlider(event.target);
  initStatementAccordion(event.target);
});
